var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "introduce" },
    _vm._l(_vm.images, function (item, index) {
      return _c("img", {
        key: index,
        attrs: { src: item },
        on: {
          click: function ($event) {
            return _vm.preview(_vm.images, index)
          },
        },
      })
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }